import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import classNames from 'classnames';
import styles from './a-text.module.scss';
export const AText = (props)=>{
    return /*#__PURE__*/ _jsx(Text, {
        ...props,
        className: classNames(props.className, styles.text)
    });
};

//# sourceMappingURL=AText.js.map